import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { UserLoginService } from "../../../service/user-login.service";
import { CognitoCallback, LoggedInCallback } from "../../../service/cognito-util.service";
import { MatDialog, MatDialogRef} from '@angular/material';
import { DialogResultExampleDialogComponent } from './dialog-result-example-dialog.component';
import { NewPasswordDialogComponent } from'./newPasswordDialog.component';
import { GlobalEventsManagerService } from '../../../service/global-events-manager.service';
import { AuthService } from '../../../service/auth.service';
const scheduleMicrotask = Promise.resolve(null);

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements CognitoCallback, LoggedInCallback, OnInit {
  
  email: string = '1';
  password: string  = '2';
  newPassword: string = null;
  errorMessage: string = '';
  isLoading = false;

  constructor(public router: Router, private authService: AuthService,public userService: UserLoginService, public dialog: MatDialog, private globalEventsManager: GlobalEventsManagerService) { 
    console.log("LoginComponent constructor");}

  ngOnInit() {
    this.authService.authIsLoading.subscribe(
      (isLoading: boolean) => this.isLoading = isLoading
    );
    this.authService.authErrorMsg.subscribe((err: any) => {
      if(err != null) { //error
        console.log("err: " , err);
        this.errorMessage = err.message;
        console.log("result: " , this.errorMessage);
        if (this.errorMessage === 'User is not confirmed.') {
          console.log("redirecting");
          this.router.navigate(['/vahvista', this.email]);
        } 
        else if (this.errorMessage === 'User needs to set password.') {
          //console.log("redirecting to set new password");
          //this.router.navigate(['/uusi-salasana']);
          scheduleMicrotask.then(() => {
            this.openNewPasswordDialog();
          }); 
        }
        else if (this.errorMessage === '200') {
         
        }
        else{
          scheduleMicrotask.then(() => {
            this.openDialog();
          }); 
        }
      }
    });
    this.authService.authStatusChanged.subscribe((authStatus: boolean) => {
      if (authStatus) {
        this.router.navigate(['/etusivu']);
      }
    });
    this.errorMessage = null;
    //console.log("Checking if the user is already authenticated. If so, then redirect to the secure site");
    this.authService.isAuthenticated().subscribe((result:boolean) => {
      console.log('LoginComponent isAuthenticated:', result);
      if (!result) {
        scheduleMicrotask.then(() => {
          this.openDialog();
        });
      }
      else{ 
        this.router.navigate(['/etusivu']);
      } 
    });
    

  }

  onLogin() {
    if (this.email == null || this.password == null) {
      this.errorMessage = "All fields are required";
      return;
    }
    this.errorMessage = null;
    this.authService.signIn(this.email, this.password, this.newPassword );
  }

  cognitoCallback(message: string, result: any) {
    if (message != null) { //error
      this.errorMessage = message;
      console.log("result: " , this.errorMessage);
      if (this.errorMessage === 'User is not confirmed.') {
        console.log("redirecting");
        this.router.navigate(['/vahvista', this.email]);
      } 
      else if (this.errorMessage === 'User needs to set password.') {
        console.log("redirecting to set new password");
        this.router.navigate(['/uusi-salasana']);
      }
      else {
        scheduleMicrotask.then(() => {
          this.openDialog();
        }); 
      }
    } else { //success
      
      this.globalEventsManager.isLoggedIn.emit(true);
      this.router.navigate(['/etusivu']);
    }
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (isLoggedIn) {
      console.log("isLoggedIn");
      this.globalEventsManager.isLoggedIn.emit(true);
      this.router.navigate(['/etusivu']);
    }
    else{
      scheduleMicrotask.then(() => {
        this.openDialog();
      });
    }
      

  }

  openNewPasswordDialog() {
    let dialogRef = this.dialog.open(NewPasswordDialogComponent,{ data: {errorMessage: this.errorMessage} })
    dialogRef.afterClosed().subscribe(result => {
      console.log('result: ',result);
      if(result){
        if(result==="forgotPassword"){
          this.router.navigate(['/unohtunutSalasana']);  
        }
        else {
          this.email = result.username;
          this.password = result.temporaryPassword;
          this.newPassword = result.password;
          this.onLogin();
        }
      }
      else {
        this.router.navigate(['/etusivu']);
      }
    });
  }
  
  openDialog() {
    let dialogRef = this.dialog.open(DialogResultExampleDialogComponent,{ data: {errorMessage: this.errorMessage} })
    dialogRef.afterClosed().subscribe(result => {
      console.log('result: ',result);
      if(result){
        if(result==="forgotPassword"){
          this.router.navigate(['/unohtunutSalasana']);  
        }
        else {
          this.email = result.username;
          this.password = result.password;
          this.newPassword = null;
          this.onLogin();
        }
      }
      else {
        this.router.navigate(['/etusivu']);
      }
    });
  }
}






// WEBPACK FOOTER //
// ./src/app/public/auth/login/login.component.ts